import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Box, Link, Text } from '@nerdwallet/currency';
import {
  setTrk,
  TrkTag,
  TrkElement,
} from '@nerdwallet/nw-client-lib/trk-helper';
import uuid from 'uuid/v4';

import { Impression } from '@nerdwallet/analytics/react/impression';
import { ElementImpression } from '@nerdwallet/nw-client-lib/tracking';

import { boolCheckboxSpec } from '../../lib/editing-configs';
import './sticky-header.less';

const StickyHeaderBox = ({
  name: sectionName,
  url: sectionUrl,
  shouldTrack,
}) => {
  const nodeId = uuid();
  const [trkId] = useState(nodeId);

  const elementImpressionProps = {
    id: `sticky-header-${trkId}`,
    elementName: 'StickyHeader',
  };

  const isAnchorLink = (sectionUrl || '').charAt(0) === '#';
  const modifiedUrl = isAnchorLink
    ? sectionUrl
    : sectionUrl &&
      setTrk({
        url: sectionUrl,
        params: {
          [TrkTag.location]: 'StickyHeader',
          [TrkTag.element]: TrkElement.hyperlink,
          [TrkTag.copy]: sectionName?.toLowerCase(),
          [TrkTag.sectionCategory]: 'StickyHeader--header',
        },
      });
  const url = shouldTrack ? modifiedUrl : sectionUrl;

  const navigationOutput = (
    <Box id={sectionName} className="sticky-header__item">
      <Link href={url}>
        <Text bold size="x-small" component="a" color="neutral-dark">
          {sectionName}
        </Text>
      </Link>
    </Box>
  );

  const navigationOutputWithTrk = (
    <Impression eventType="element_impression" entityName="sticky_header">
      <ElementImpression {...elementImpressionProps}>
        {navigationOutput}
      </ElementImpression>
    </Impression>
  );

  const stickyHeaderBoxOutput = shouldTrack
    ? navigationOutputWithTrk
    : navigationOutput;

  return stickyHeaderBoxOutput;
};

StickyHeaderBox.propTypes = {
  name: PropTypes.string,
  url: PropTypes.string,
  shouldTrack: PropTypes.bool,
};

StickyHeaderBox.defaultProps = {};

StickyHeaderBox.getEditingConfig = () => {
  return [
    boolCheckboxSpec(
      'shouldTrack',
      'Add BOA Awards analytics instrumentation?'
    ),
  ];
};

StickyHeaderBox.displayName = 'StickyHeader';

export default StickyHeaderBox;
